import {exhaustive} from '@freckle/exhaustive'
import {
  primaryPanel,
  successPanel,
  infoPanel,
  warningPanel,
  dangerPanel,
  defaultPanel
} from './student-group-panel.module.scss'

export type PanelStyleT = 'primary' | 'success' | 'info' | 'warning' | 'danger' | 'default'

export function getCardHeaderClass(panelStyle: PanelStyleT): string {
  switch (panelStyle) {
    case 'primary':
      return primaryPanel
    case 'success':
      return successPanel
    case 'info':
      return infoPanel
    case 'warning':
      return warningPanel
    case 'danger':
      return dangerPanel
    case 'default':
      return defaultPanel
    default:
      return exhaustive(panelStyle)
  }
}
